/* eslint-disable prefer-named-capture-group */
import url from 'url'
import config from 'config'

export const assetUrl = path => {
  const baseUrl = config.NEXT_PUBLIC_SITE_ASSETS_URL
  const parsed = new URL(baseUrl + path)
  return parsed.href
}

// ==========================================
// Is URL ?
// ==========================================
//
// -  Determines if string is a valid url
//
//    Source of regex:
//    https://stackoverflow.com/questions/5717093/check-if-a-javascript-string-is-a-url

const urlPattern = new RegExp(
  // protocol
  '^(https?:\\/\\/)?' +
    // domain name and extension
    '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' +
    // OR ip (v4) address
    '((\\d{1,3}\\.){3}\\d{1,3}))' +
    // port
    '(\\:\\d+)?' +
    // path
    '(\\/[-a-z\\d%@_.~+&:]*)*' +
    // query string
    '(\\?[;&a-z\\/\\d%@_.,~+&:=-]*)?' +
    // fragment locator
    '(\\#[-a-z\\d_]*)?$',
  'i'
)

export const isUrl = s => urlPattern.test(s)

const SLASHED_PROTOCOLS = ['http:', 'https:', 'ftp:']
const NOT_SLASHED_PROTOCOLS = ['mailto:', 'tel:']
export const isValidUrl = s => {
  try {
    const { protocol } = new URL(s)

    if (SLASHED_PROTOCOLS.includes(protocol)) {
      // additional check to prevent false triggering for urls link http:google.com
      return s.indexOf('//') !== -1
    }

    return NOT_SLASHED_PROTOCOLS.includes(protocol)
  } catch (_) {
    return false
  }
}

// ==========================================
// Query Params
// ==========================================
//
// - returns all params
// - otherwise returns empty object
//
export const queryParams = u => url.parse(u, true).query || {}

// ==========================================
// Path
// ==========================================
//
// - returns url path component
//
export const path = u => url.parse(u, true).pathname || ''

// ==========================================
// Add Protocol if missing
// ==========================================
//
// -  given url string, adds https://'
//    if no protocol
//
export const addProtocol = s => {
  if (!s) {
    return s
  }
  if (s.startsWith('http://') || s.startsWith('https://')) {
    return s
  } else if (s.startsWith('//')) {
    return 'https:' + s
  }
  return 'https://' + s
}

// ==========================================
// Strip trailing slash for checking
// ==========================================
//
// -  given url string, removes trailing / if it exists
//
export const stripSlash = u => u && u.replace(/\/$/, '')

// ==========================================
// Redirect to URL if not current URL
// ==========================================
//
// -  given redirectURL + pageURL, return redirectURL if pageURL != redirectURL else, return undefined
//
export function checkIfOnPageElseRedirect(redirectURL, pageURL) {
  pageURL = url.parse(pageURL).pathname
  if (pageURL == redirectURL) {
    return
  }
  return redirectURL
}

// ==========================================
// Is relative path ?
// ==========================================
//
// -  Determines if string is a relative path

export const isRelativePath = redirectUrl => {
  return !(redirectUrl.indexOf('://') > 0 || redirectUrl.indexOf('//') === 0)
}
